import React, { useCallback, useEffect, useState } from 'react';
import * as yup from 'yup';
import Group from '../../../components/form/elements/group';
import Text from '../../../components/form/elements/text';
import Form, { FormComponent, SubmitType } from '../../../components/form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useService } from '../../../services/services';
import Checkbox from '../../../components/form/elements/checkbox';
import Link from '../../../components/form/elements/link';
import Ability from '../../../interfaces/ability';
import Button from '../../../components/form/elements/button';
import {
  INTERNAL_ROLES_INDEX,
  INTERNAL_ROLES_VIEW,
} from '../../../router/routes';
import { route } from '../../../services/utils';
import { map } from 'rxjs/operators';
import { useObservableState } from 'observable-hooks';
import Role from '../../../interfaces/role';

const createRoleSchema = yup.object().shape({
  name: yup.string().max(255).required(),
  title: yup.string().max(255).required(),
  abilities: yup.object(),
});

export default function CreateRole() {
  const { t } = useTranslation();
  const history = useHistory();
  const { roleService, abilityService } = useService();
  const [bodyElements, setBodyElements] = useState([]);
  const [footerElements, setFooterElements] = useState([]);

  const [abilities] = useObservableState<FormComponent[]>(
    () =>
      abilityService
        .index()
        .pipe(
          map((abilities: Ability[]) =>
            abilities.map((ability) =>
              Checkbox(`abilities.${ability.id}`, ability.title)
            )
          )
        ),
    null
  );

  useEffect(() => {
    if (abilities !== null) {
      setBodyElements([Group([Text('name'), Text('title'), ...abilities])]);

      setFooterElements([
        Button('create'),
        Link(INTERNAL_ROLES_INDEX, 'cancel'),
      ]);
    }
  }, [abilities, setBodyElements, setFooterElements]);

  const submit = useCallback<SubmitType<Role>>(
    (form) => [
      roleService.store(form),
      (response) =>
        history.push(route(INTERNAL_ROLES_VIEW, { id: response.id })),
    ],
    [roleService, history]
  );

  return (
    <Form
      title={t('pages.internal.roles.Create role')}
      mode={'create'}
      body={bodyElements}
      footer={footerElements}
      submit={submit}
      schema={createRoleSchema}
    />
  );
}
